import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import "../../assets/styles/objecthistory.scss";
import { FaSortAmountDown, FaSortAmountUpAlt } from "react-icons/fa";
import { IoIosCloseCircleOutline } from "react-icons/io";
import toast from "react-hot-toast";
import { activeloglist } from "../../api/actions/activitylog";
import { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spinner } from "react-bootstrap";
import { Tooltip } from "@mui/material";

const Objecthistory = ({ isOpenhistory, setIsOpenhistory, id }) => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(25);
  const [order, setOrder] = useState("desc");
  const [hasMore, setHasMore] = useState(true);
  const isSortingRef = useRef(false);

  const fetchInitialLogs = async () => {
    setHasMore(true);
    setPage(1);

    activeloglist({
      page: 1,
      limit,
      object_id: id,
      order,
    })((response) => {
      if (response?.status) {
        const results = response?.data?.results || [];
        setData(results);

        if (results.length < limit) {
          setHasMore(false);
        }
        isSortingRef.current = false;
      } else {
        setHasMore(false);
        isSortingRef.current = false;
      }
    });
  };

  const fetchMoreLogs = async () => {
    if (isSortingRef.current) return;
    const nextPage = page + 1;

    activeloglist({
      page: nextPage,
      limit,
      object_id: id,
      order,
    })((response) => {
      if (response?.status) {
        const results = response?.data?.results || [];

        setData((prev) => [...prev, ...results]);
        setPage(nextPage);

        if (results.length < limit) {
          setHasMore(false);
        }
      } else {
        setHasMore(false);
      }
    });
  };

  useEffect(() => {
    fetchInitialLogs();
  }, [isOpenhistory, order]);

  return (
    <div
      className="comment-wrapper"
      style={{
        height: "100vh",
        backgroundColor: "rgb(226 241 255 / 50%)",
        scrollbarWidth: "none",
      }}
    >
      <div className="cmt-header">
        <h4 style={{ marginLeft: "10px" }}>History</h4>
        <div className="icon-div">
          <div className="accordion-icon">
            <Tooltip
              title={order === "asc" ? "Sort Descending" : "Sort Ascending"}
            >
              <span>
                {order === "asc" ? (
                  <FaSortAmountDown
                    size={20}
                    onClick={() => {
                      isSortingRef.current = true;
                      setData([]);
                      setOrder(order === "asc" ? "desc" : "asc");
                    }}
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  <FaSortAmountUpAlt
                    size={20}
                    onClick={() => {
                      isSortingRef.current = true;
                      setData([]);
                      setOrder(order === "asc" ? "desc" : "asc");
                    }}
                    style={{ cursor: "pointer" }}
                  />
                )}
              </span>
            </Tooltip>
          </div>
          <div className="accordion-icon">
            <IoIosCloseCircleOutline
              className="comment_clossing"
              style={{ cursor: "pointer" }}
              onClick={() => setIsOpenhistory(false)}
              size={25}
            />
          </div>
        </div>
      </div>

      <Form
        id="scrollableDiv"
        style={{ paddingTop: "30px", overflow: "auto", maxHeight: "90vh" }}
      >
        <InfiniteScroll
          dataLength={data.length}
          next={fetchMoreLogs}
          hasMore={hasMore}
          loader={
            <h6 style={{ textAlign: "center", margin: "10px" }}>
              <Spinner />
            </h6>
          }
          scrollableTarget="scrollableDiv"
          style={{ overflow: "visible" }}
        >
          {data.map((li, index) => (
            <Container key={index} className="objecthistory_container">
              <div className="content_full_div">
                <div className="name_date">
                  <div className="department_name">
                    <p className="name_p_tag">{li?.created_by_name}</p>
                    <p className="department_p_tag">{li?.department}</p>
                  </div>
                  <p className="date_p_tag">{li?.created_date}</p>
                </div>
                <div className="history_div">
                  <p className="history_p_tag">
                    {li?.description_for_admins?.split("_").join(" ")}
                  </p>
                </div>
              </div>
            </Container>
          ))}
        </InfiniteScroll>
      </Form>
    </div>
  );
};

export default Objecthistory;
